import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const NoOcurrence = ({ message = "Nada consta" }) => {
  return (
    <div className="relative mt-4 overflow-hidden rounded-2xl border border-blue-200 bg-blue-50 shadow-sm">
      <div className="absolute inset-y-0 left-0 w-1 bg-blue-500/70" />
      <div className="flex items-center gap-4 px-4 py-2">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-blue-200 bg-blue-50 text-blue-600 shadow-inner">
          <IoMdCheckmarkCircleOutline className="h-6 w-6" />
        </span>
        <div className="min-w-0">
          <div className="text-base font-semibold text-slate-800">
            {message}
          </div>
          <div className="text-xs text-blue-800">
            Nenhuma ocorrência registrada neste bloco.
          </div>
        </div>
        <div className="ml-auto hidden rounded-full border border-blue-200 bg-blue-100 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-emerald-700 sm:inline-flex">
          OK
        </div>
      </div>
    </div>
  );
};
export default NoOcurrence;
